export default __webpack_public_path__ + "static/about-eca59a4aa3231812796a8a511656d679.png";